import { useAtom } from '@reatom/npm-react'
import { useState } from 'react'
import styled from 'styled-components'

import {
  SPECIAL_PAIRS_SORT_KEYS,
  type ExploreSortKey,
  type SpecialPairsSorting,
} from '../../atoms/reatom-explore-top-gainers'

import { ExploreSortingSelect } from './explore-sorting-select'

import type { AtomMut } from '@reatom/framework'

type Props = {
  model: AtomMut<SpecialPairsSorting>
}

export const ExploreSorting: React.FC<Props> = ({ model }) => {
  const [sortingOpen, setSortingOpen] = useState(false)
  const [sortBy, setSortBy] = useAtom(model)

  const handleChangeSortBy = (value: ExploreSortKey) => {
    setSortingOpen(false)
    setSortBy(() => ({
      sortBy: value,
      sortDir: 'desc',
    }))
  }
  const handleToggleSortDir = () => {
    setSortBy((prev) => ({
      ...prev,
      sortDir: prev.sortDir === 'asc' ? 'desc' : 'asc',
    }))
  }

  return (
    <Root>
      <ExploreSortingSelect
        options={SPECIAL_PAIRS_SORT_KEYS}
        value={sortBy.sortBy}
        sortDir={sortBy.sortDir}
        open={sortingOpen}
        onOpenChange={setSortingOpen}
        onSortByChange={handleChangeSortBy}
        onSortDirToggle={handleToggleSortDir}
      />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
`
